












































































import { Component, Vue, Watch } from "vue-property-decorator";
import { menuList, pathList, bgList } from "./headList";
import { register, getCode } from "@/req/homes";

@Component({
  components: {},
})
export default class Home extends Vue {
  public modal = false;
  public username = "";
  public password = "";
  public phone = "";
  public code = "";
  public agree = false;
  public isCode = false;
  public second = 60;
  public timer: any = null;
  public show() {
    this.modal = true;
  }
  public async handleSubmit() {
    if (this.$fn.isNull(this.username)) {
      this.$Message.error("请输入账号名");
      return;
    }
    // 不区分大小写 包含数字 字母 符号 8-32
    const pwdRegex = new RegExp(
      "(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,32}"
    );

    if (!pwdRegex.test(this.password)) {
      this.$Message.error(
        "您的密码复杂度太低（密码中必须包含字母、数字、特殊字符），且长度在8-32位之间"
      );
      return;
    }
    if (
      this.$fn.isNull(this.password) &&
      (this.password.length <= 8 || this.password.length >= 32)
    ) {
      this.$Message.error("密码不能为空，且长度在8-32位之间");
      return;
    }
    if (!this.$fn.isPhone(this.phone)) {
      this.$Message.error("请输入符合规范的手机号");
      return;
    }
    if (this.$fn.isNull(this.code)) {
      this.$Message.error("请输入验证码");
      return;
    }
    const obj = {
      username: this.username,
      password: this.password,
      phone: this.phone,
      code: this.code,
    };
    const res = await register(obj);
    if (res.code == 200) {
      this.$Message.success(res.msg);
      this.cancel();
      // window.open(
      //   "http://pure-engine.996yinqing.com/#/login",
      //   "_blank"
      // );
    } else {
      this.$Message.error(res.msg);
    }
  }
  public agreementClick() {
    window.open("https://docs.qq.com/doc/DWkNKWFFqekFJV2lF", "_blank");
  }
  public toLogin() {
    window.open("http://pure-engine.996yinqing.com/", "_blank");
  }
  public cancel() {
    this.username = "";
    this.password = "";
    this.phone = "";
    this.code = "";
    this.isCode = false;
    this.modal = false;
  }
  public async getCode() {
    if (this.isCode) return;
    if (!this.$fn.isPhone(this.phone)) {
      this.$Message.error("请输入符合规范的手机号");
      return;
    }
    this.isCode = true;
    const res = await getCode({ phone: this.phone });
    if (res.code != 200) {
      this.isCode = false;
      this.$Message.error(res.msg);
      return;
    }
    this.timer = setInterval(() => {
      if (this.second <= 0) {
        this.isCode = false;
        this.second = 60;
        clearInterval(this.timer);
        return;
      }
      this.second -= 1;
    }, 1000);
  }
  public beforeDestroy() {
    clearInterval(this.timer);
  }
}
